export const prodesign = {
  id: "prodesign",
  code: "05",
  brand: "ProDesign",
  nameJa: "SNS運用 / Webデザイン",
  nameEn: "SNS Marketing & Web Design",
  accent: "primary",
  icon: "ri-palette-line",
  taglineJa: "投稿画像からサイトデザインまで、世界観をひとつに。",
  taglineEn: "One visual language, from social posts to your website.",
  leadJa:
    "Instagram・X・LinkedInの投稿クリエイティブから、ランディングページ、コーポレートサイトまでを手がけます。バラバラになりがちなタッチを、ブランドとして一貫した世界観に整理し、運用まで含めて設計します。",
  leadEn:
    "Post-level creative for Instagram, X and LinkedIn, plus landing pages and corporate sites — unified into one brand voice and kept running.",
  heroImage:
    "/images/prodesign.jpg",
  stats: [
    { value: "850", unit: "件", labelJa: "累計制作実績", labelEn: "Projects delivered" },
    { value: "7", unit: "営業日", labelJa: "平均納品日数", labelEn: "Average turnaround" },
    { value: "98", unit: "%", labelJa: "投稿運用の継続率", labelEn: "Posting retention" },
    { value: "12", unit: "名", labelJa: "在籍デザイナー", labelEn: "In-house designers" },
  ],
  challenges: [
    {
      icon: "ri-image-line",
      titleJa: "投稿画像が毎回バラバラ",
      titleEn: "Inconsistent visuals",
      descJa: "担当者が変わるたびに色も書体も変わり、フィード全体に統一感が出ていない状態になっていませんか。",
    },
    {
      icon: "ri-hourglass-line",
      titleJa: "外注すると納品が遅い",
      titleEn: "Slow turnaround",
      descJa: "1枚のバナーに1週間かかると、タイムリーな話題に乗れず機会損失になります。",
    },
    {
      icon: "ri-layout-masonry-line",
      titleJa: "サイトとSNSの印象が違う",
      titleEn: "Brand disconnect",
      descJa: "SNSで受けた印象とサイトを開いたときの印象に差があり、離脱につながるケースがあります。",
    },
  ],
  strengths: [
    {
      icon: "ri-book-open-line",
      titleJa: "ブランドガイドの設計",
      titleEn: "Brand guidelines",
      descJa: "色・書体・余白・写真のトーンをルール化し、誰が作っても同じ印象になる状態をつくります。",
    },
    {
      icon: "ri-calendar-2-line",
      titleJa: "定額制で継続できる",
      titleEn: "Flat monthly fee",
      descJa: "月額固定で投稿デザインを継続制作。毎月の見積もり調整なしで運用できます。",
    },
    {
      icon: "ri-flashlight-line",
      titleJa: "7営業日で納品",
      titleEn: "7 business days",
      descJa: "初稿は最短7営業日でご提出。急ぎのご依頼は別途ご相談ください。",
    },
    {
      icon: "ri-links-line",
      titleJa: "WebとSNSを同一チームで",
      titleEn: "One team, one voice",
      descJa: "グループ内でWeb制作とSNS制作を同じチームが担当するため、世界観のズレが起きません。",
    },
  ],
  menu: [
    {
      icon: "ri-instagram-line",
      titleJa: "SNS投稿デザイン",
      titleEn: "Social post design",
      descJa: "フィード画像・ストーリーズ・カルーセルの制作と、投稿計画の設計を行います。",
    },
    {
      icon: "ri-video-line",
      titleJa: "ショート動画編集",
      titleEn: "Short video editing",
      descJa: "リール・TikTok向けの縦動画を、テロップとサムネイル込みで制作します。",
    },
    {
      icon: "ri-window-line",
      titleJa: "ランディングページ制作",
      titleEn: "Landing pages",
      descJa: "訴求設計からワイヤーフレーム、デザイン、実装までを一貫して担当します。",
    },
    {
      icon: "ri-global-line",
      titleJa: "コーポレートサイト制作",
      titleEn: "Corporate websites",
      descJa: "採用・集客など目的に合わせたサイト設計と、更新しやすい運用体制の構築を行います。",
    },
    {
      icon: "ri-pen-nib-line",
      titleJa: "ロゴ・ブランドガイド",
      titleEn: "Logo & brand identity",
      descJa: "ロゴ制作とあわせて、利用ルールをまとめたブランドガイドを納品します。",
    },
  ],
  pricing: [
    {
      nameJa: "SNSプラン",
      nameEn: "Social plan",
      price: "月額 55,000円",
      priceNote: "税別 / 月15投稿",
      descJa: "SNSの見た目を整えて、継続的に発信したい方へ。",
      features: ["月15投稿のデザイン", "投稿計画の設計", "修正2回まで", "月次レポート"],
      recommended: false,
    },
    {
      nameJa: "LP制作プラン",
      nameEn: "Landing page",
      price: "180,000円〜",
      priceNote: "税別 / 1ページ",
      descJa: "広告やキャンペーンの受け皿をしっかり作りたい方へ。",
      features: ["訴求設計・構成案", "デザインカンプ", "レスポンシブ実装", "修正3回まで"],
      recommended: true,
    },
    {
      nameJa: "ブランド一括プラン",
      nameEn: "Brand package",
      price: "要お見積り",
      priceNote: "税別",
      descJa: "ロゴからサイト、SNSまでまとめて整えたい方へ。",
      features: ["ロゴ制作", "ブランドガイド", "コーポレートサイト", "SNSテンプレート一式"],
      recommended: false,
    },
  ],
  priceNoteJa: "表示金額はすべて税別の目安です。ページ数・素材の有無により個別にお見積りします。",
  flow: [
    { step: "01", titleJa: "ヒアリング", titleEn: "Discovery", descJa: "ブランドの印象と、届けたい相手を伺います。" },
    { step: "02", titleJa: "ムードボード", titleEn: "Moodboard", descJa: "方向性を2〜3案のビジュアルで共有し、認識を揃えます。" },
    { step: "03", titleJa: "初稿提出", titleEn: "First draft", descJa: "デザインの初稿をご提出。修正を重ねて仕上げます。" },
    { step: "04", titleJa: "納品・運用", titleEn: "Delivery", descJa: "データ納品後、必要に応じて運用まで継続支援します。" },
  ],
  faq: [
    { q: "修正は何回までできますか？", a: "プランにより異なりますが、SNSプランは2回、LP制作は3回までを目安としています。大幅な方向転換は別途お見積りとなります。" },
    { q: "写真素材がなくても依頼できますか？", a: "問題ありません。フリー素材の選定や、必要に応じて撮影手配・生成画像の活用もご提案できます。" },
    { q: "制作したデザインの権利はどうなりますか？", a: "納品物の利用権はお客様に帰属します。当社は実績として掲載させていただく場合がございますので、不可の場合はお知らせください。" },
    { q: "急ぎの依頼は可能ですか？", a: "通常7営業日ですが、3営業日程度の特急対応も承れます（別途特急料金）。まずはご相談ください。" },
  ],
  related: ["marketing-quest", "pro-online"],
};